<div>
  <div class="row" (resized)="onResized($event)">
  <div class="report-card col-xl-2 col-lg-6 col-md-6 col-12" *ngFor="let item of leadStagereports">
    <div class="card  bg-lighten-3" [class]="item.bg">
      <div class="card-content">
        <div class="card-body py-0">
          <div class="media">
            <div class="media-body  text-left" [class]="item.textColor">
              <h3 class="font-large-1  mb-0" [class]="item.textColor">{{item?.total}}</h3>
              <span>{{item?.displayname}}</span>
            </div>
            <div class="media-right  text-right" *ngIf="item.name!=='prospect'" [class]="item.textColor">
              ({{item?.percent}} %)
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<section>
  <div class="d-flex">
<div class="col-3" *ngIf="selected_filter !=''">
      <ng-select [items]="filterList" bindLabel="name" placeholder="Select Filter"
        [(ngModel)]="selected_filter" [ngModelOptions]="{standalone: true}" (change)="getFilter($event)">
      </ng-select>
  </div>
  <div class="col-6" *ngIf="currentUrl =='training-leads-reports'">
    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Training Leads Guideline</button>
  </div>
  <div class="col-6" *ngIf="currentUrl =='outsource-leads-reports'">
    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Outsource Leads Guideline</button>
  </div>
  </div>

  
</section>
<!-- Bar Chart Starts -->
<div class="row text-left">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title" *ngIf="currentUrl =='training-leads-reports'">Training Leads Report</h4>
                <h4 class="card-title" *ngIf="currentUrl =='outsource-leads-reports'">Outsource Leads Report</h4>
                <div class="float-right cursor-pointer monthyeardropdown mb-1">
                  <div class="row">
                    <div class='col-12 col-sm-5'>
                      <input
                        type="date"
                        class="form-control"
                        (change)="getReports()"
                        [(ngModel)]="leadFromDate" [ngModel]="leadFromDate | date: 'yyyy-MM-dd'" [disabled]="false"
                        id="last_activedate"
                        placeholder="Enter last active date"
                      />
                    </div>
                    <h6 style="align-items: center;
                    display: flex;">To</h6>
                    <div class='col-12 col-sm-5'>
                      <input
                        type="date"
                        (change)="getReports()"
                        class="form-control"
                        [(ngModel)]="leadToDate" [ngModel]="leadToDate | date: 'yyyy-MM-dd'" [disabled]="false"
                        id="last_activedate"
                        placeholder="Enter last active date"
                      />
                    </div>
                    <div class="col-12 my-2">
                      <span class="bg-light-primary badge badge-pill mx-1" (click)="todayFilterReports()">Today</span>
                      <span class="bg-light-primary badge badge-pill mx-1" (click)="dayFilterReports()">Last 3 Days</span>
                      <span class="bg-light-primary badge badge-pill mx-1" (click)="weekFilterReports()">This Week</span>
                      <span class="bg-light-primary badge badge-pill mx-1" (click)="monthFilterReports()">This Month</span>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-lg-12">      
                      <div id="line-chart1" class="height-350">
                       <apx-chart
                    [series]="columnChartOptions?.series"
                    [colors]="columnChartOptions?.colors"
                    [chart]="columnChartOptions?.chart"
                    [xaxis]="columnChartOptions?.xaxis"
                    [yaxis]="columnChartOptions?.yaxis"
                    [title]="columnChartOptions?.title"
                    [dataLabels]="columnChartOptions?.dataLabels"
                    [stroke]="columnChartOptions?.stroke"
                    [grid]="columnChartOptions?.grid"
                    [tooltip]="columnChartOptions?.tooltip"
                    [plotOptions]="columnChartOptions?.plotOptions"
                    [fill]="columnChartOptions?.fill"
                    [legend]="columnChartOptions?.legend"
                    [labels]="columnChartOptions?.labels"
                    [markers]="columnChartOptions?.markers"
                    [theme]="columnChartOptions?.theme"
                    [responsive]="columnChartOptions?.responsive"
                  ></apx-chart>
                      </div>
            </div>
        </div>
    </div>
</div>
<div class="row text-left" *ngIf="currentUrl =='outsource-leads-reports'">
  <div class="col-sm-12">
      <div class="card">
          <div class="card-header">
              <h4 class="card-title" *ngIf="currentUrl =='training-leads-reports'">Training Channel Leads Report</h4>
              <h4 class="card-title" *ngIf="currentUrl =='outsource-leads-reports'">Outsource Channel Leads Report</h4>
              <div class="float-right cursor-pointer monthyeardropdown mb-1">
                <div class="row">
                <div class="col-12 col-sm-3 dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                  <button type="button" class="btn btn-outline-primary btn1">{{selectedTechnology}}</button>
                  <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                    aria-haspopup="true" aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <div ngbDropdownMenu class="dropdown-menu" role="menu">
                    <button class="dropdown-item" *ngFor="let item of technology_List" (click)="getChannelReport(item?._id,item?.displayname,channelFromDate,channelToDate)">{{item.displayname}}</button>
                  </div>
                </div>
                  <div class='col-12 col-sm-2'>
                    <ng-select [items]="sourceList" bindLabel="displayname" bindValue="_id" [disabled]="false"
                      placeholder="Select Source" [(ngModel)]="selected_source"
                       (change)="getChannelReport(selectedTechnologyId,selectedTechnology,channelFromDate,channelToDate)">
                    </ng-select>
                  </div>
                  <div class='col-12 col-sm-3'>
                    <input
                      type="date"
                      class="form-control"
                      (change)="getChannelReport(selectedTechnologyId,selectedTechnology,channelFromDate,channelToDate)"
                      [(ngModel)]="channelFromDate" [ngModel]="channelFromDate | date: 'yyyy-MM-dd'" [disabled]="false"
                      id="last_activedate"
                      placeholder="Enter last active date"
                    />
                  </div>
                  <h6 style="align-items: center;
                  display: flex;">To</h6>
                  <div class='col-12 col-sm-3'>
                    <input
                      type="date"
                      (change)="getChannelReport(selectedTechnologyId,selectedTechnology,channelFromDate,channelToDate)"
                      class="form-control"
                      [(ngModel)]="channelToDate" [ngModel]="channelToDate | date: 'yyyy-MM-dd'" [disabled]="false"
                      id="last_activedate"
                      placeholder="Enter last active date"
                    />
                  </div>
                  <div class="col-12 my-2">
                    <span class="bg-light-primary badge badge-pill mx-1" (click)="todayFilterChannelReports()">Today</span>
                    <span class="bg-light-primary badge badge-pill mx-1" (click)="dayFilterChannelReports()">Last 3 Days</span>
                    <span class="bg-light-primary badge badge-pill mx-1" (click)="weekFilterChannelReports()">This Week</span>
                    <span class="bg-light-primary badge badge-pill mx-1" (click)="monthFilterChannelReports()">This Month</span>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-lg-12">      
                    <div id="line-chart1" class="height-350">
                     <apx-chart
                  [series]="channelChartOptions?.series"
                  [colors]="channelChartOptions?.colors"
                  [chart]="channelChartOptions?.chart"
                  [xaxis]="channelChartOptions?.xaxis"
                  [yaxis]="channelChartOptions?.yaxis"
                  [title]="channelChartOptions?.title"
                  [dataLabels]="channelChartOptions?.dataLabels"
                  [stroke]="channelChartOptions?.stroke"
                  [grid]="channelChartOptions?.grid"
                  [tooltip]="channelChartOptions?.tooltip"
                  [plotOptions]="channelChartOptions?.plotOptions"
                  [fill]="channelChartOptions?.fill"
                  [legend]="channelChartOptions?.legend"
                  [labels]="channelChartOptions?.labels"
                  [markers]="channelChartOptions?.markers"
                  [theme]="channelChartOptions?.theme"
                  [responsive]="channelChartOptions?.responsive"
                ></apx-chart>
                    </div>
          </div>
      </div>
  </div>
<!-- Bar Chart Ends -->

